<template>
  <div class="home">
    <div class="section">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <div class="card">
            <div class="card-header">
              <h2 class="card-header-title">Entrega de alimentación</h2>
            </div>
            <div class="card-content">
              <img alt="Vue logo" src="../assets/logo.png" />
              <HelloWorld msg="Bienvenido a casino app" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
  },
};
</script>
